import { countBy, get, isEmpty, some } from "lodash-es";
import { isBlank, isNumeric } from "./helpers";

export const required = (value) => (isBlank(value) ? "Required" : undefined);
export const requiredTrue = (value) => (value === true ? undefined : "Required");

export const requiredMoneyPresent = (value) => {
  const req = required(value);
  if (req) {
    return req;
  }

  if (value == "$") {
    return "Required";
  }
};
export const requiredNotNull = (value) => (value != null ? undefined : "Required");
export const numeric = (value) => (isNumeric(value) ? undefined : "Value must be a number");
export const numericOrNull = (value) => (isEmpty(value) || isNumeric(value) ? undefined : "Value must be a number");
export const numericInRange = (min, max) => (value) =>
  isEmpty(value) || ([value, min, max].every((v) => isNumeric(v)) && value >= min && value <= max)
    ? undefined
    : `Value must be between ${min} and ${max}`;
export const wholeNumber = (value) => (parseInt(value).toString() === value.toString() ? undefined : "Value must be a whole number");
export const naiveUrl = (value) => (value.startsWith("http") ? undefined : "Your URL must start with http:// or https://");

export const isNaivePath = (value) => (value.startsWith("/") ? undefined : "Your path must start with /");
export const isNotNaivePath = (value) => (value.startsWith("/") ? "Your path must not start with /" : undefined);

export const noPathTraversal = (value) => (value.includes("..") ? "Your path must be absolute" : undefined);

export const atLeastOneFieldRequired = (other) => (value, allValues) =>
  !value && !allValues[other] ? "At least one field is required" : undefined;

export const atLeastOneOfMultipleFieldsRequired = (other) => (value, allValues) =>
  !value && !other.some((k) => k in allValues) ? "At least one field is required" : undefined;

export const atLeastOneFieldWithMoneyRequired = (other) => (value, allValues) =>
  !(!requiredMoneyPresent(value) || !requiredMoneyPresent(allValues[other])) ? "At least one field is required" : undefined;

export const atLeastTwoValuesMustBeSelected = (value) => (value?.length >= 2 ? undefined : "At least two values must be selected");

export const distinctValues = (path, key) => (value, allValues) => {
  const collection = get(allValues, path, []);
  const countsByKey = countBy(collection, key);
  const count = get(countsByKey, value, 0);
  return count > 1 ? "Value must be unique." : undefined;
};

export const valueInOptions = (options) => (value) =>
  some(options, (o) => o.value === value) ? undefined : `Please select from available options`;

export const validNpi = (value) => {
  if (isEmpty(value)) return;
  if (!/^\d+$/.test(value)) return "Enter only numeric digits for the NPI";
  if (value.length !== 10) return "NPI must be exactly 10 digits long.";
};

export const requiredIf = (otherFieldPath) => {
  return (value, allValues) => {
    const otherValue = get(allValues, otherFieldPath);

    if (!isEmpty(otherValue) && isEmpty(value)) {
      return "Required";
    }
    return undefined;
  };
};

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined);
